import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=20e59a3e&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=20e59a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e59a3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sebastian/Projekte/CD-Systeme/nextgenkonfi/konfiguratornextgen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e59a3e')) {
      api.createRecord('20e59a3e', component.options)
    } else {
      api.reload('20e59a3e', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=20e59a3e&scoped=true&", function () {
      api.rerender('20e59a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/Loader.vue"
export default component.exports